// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"de59e5bf","360":"d6f2f39e","408":"2b80e9d0","453":"56f593cb","578":"e777f7a5","889":"308f9b42","905":"e8fb6eb7"}[chunkId] + ".chunk.js";
};